(function init() {
  angular.module('app').controller('host.views.debugTools.migrateCollateralAndCreditLimit.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    'uiGridConstants',
    function controller($uibModalInstance, debugToolSvc, uiGridConstants) {
      const vm = this;
      vm.saving = 0;

      vm.cancel = cancel;
      vm.migrate = migrate;
      vm.check = check;

      vm.input = { corporateId: null };
      vm.mismatches = null;

      vm.gridOptions = {
        paginationPageSizes: [10],
        paginationPageSize: 10,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
        columnDefs: [
          { displayName: 'Corporate Id', field: 'corporateId', width: 110 },
          { displayName: 'Name', field: 'corporateName', minWidth: 150 },
          {
            displayName: 'Old escrow amount',
            field: 'escrowAmount',
            cellFilter: 'number: 2',
            cellClass: 'text-right',
            width: 170,
          },
          {
            displayName: 'Current collateral amount',
            field: 'currentCollateralAmount',
            cellFilter: 'number: 2',
            cellClass: 'text-right',
            width: 220,
          },
        ],
        data: [],
      };

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function migrate() {
        vm.saving += 1;
        debugToolSvc
          .migrateCollateralAndCreditLimit(vm.input)
          .success(() => {
            abp.notify.info('Migration jobs enqueued');
          })
          .finally(() => {
            vm.saving -= 1;
          });
      }

      function check() {
        vm.saving += 1;
        vm.mismatches = null;
        debugToolSvc
          .getCollateralMigrationMismatches()
          .success((result) => {
            vm.mismatches = result || [];
            vm.gridOptions.data = vm.mismatches;
          })
          .finally(() => {
            vm.saving -= 1;
          });
      }
    },
  ]);
})();
